import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import get from 'lodash.get';
import { Box, FlexBox, Typography, Grid, MuiBox } from '@kis-technologies/kis-ui';
import { Footer } from 'components/Footer';
import { selectors as configSelectors, Configuration } from 'services/configuration';
import { selectors as kioskSelectors } from 'services/kiosk';
import { selectors as mediaSelectors } from 'services/media';
import { useStyles, SplashViewImage } from './styled';

const SplashView = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const kiosk = useSelector(kioskSelectors.selectKiosk);
  const config = useSelector(configSelectors.selectConfiguration) as Configuration;
  const fontFamily = get(config, 'configuration.globalSettings.fonts.primary', '');
  const messages = get(config, 'configuration.globalSettings.splashPage.messages');
  const splashHeader = get(messages, `header.${i18n.language}`);
  const splashMessage = get(messages, `message.${i18n.language}`);
  const splashImage = useSelector(mediaSelectors.selectSplashImage) || [];
  const classes = useStyles({ fontFamily })();
  const clientId = get(kiosk, 'venue.clientId');
  const previewUrl = `${process.env.REACT_APP_S3_ASSETS}/${clientId}/splash_images/`;
  const splashbuttonText = get(messages, `buttons.${i18n.language}[0]`) || t('splash.splashButtonText');

  const onNextButtonClick = () => {
    navigate('/ticketing/start-purchase');
  };

  const splashScreenHeader = () => {
    return (
      <Typography className={classes.splashHeaderText}>
        {splashHeader ? splashHeader : t('splash.splashHeader')}
      </Typography>
    );
  };

  const splashScreenMessage = () => {
    return (
      <Typography className={classes.splashText}>{splashMessage ? splashMessage : t('splash.splashText')}</Typography>
    );
  };

  return (
    <>
      <FlexBox noWrap direction="column" align="center" justify="center" padding="0 5">
        <Grid className={classes.splashContainer}>
          {splashImage && splashImage.length > 0 ? (
            <>
              {splashHeader && splashMessage ? (
                <>
                  <Grid item lg={12} xl={6} className={classes.splashImageBlock}>
                    <FlexBox bg="x-light-gray" fullHeight fullWidth>
                      <SplashViewImage alt="splash-view-image" src={`${previewUrl}${splashImage[0].s3Name}`} />
                    </FlexBox>
                  </Grid>
                  <Grid item lg={12} xl={6} className={classes.splashTextBlock}>
                    <FlexBox fullHeight align="center" justify="center" direction="column" padding="12 8">
                      <Box flexOverride="none" margin="0 0 3">
                        {splashScreenHeader()}
                      </Box>
                      <Box flexOverride="none" margin="0 0 8">
                        {splashScreenMessage()}
                      </Box>
                    </FlexBox>
                  </Grid>
                </>
              ) : (
                <FlexBox fullWidth fullHeight align="center" justify="center" direction="column" padding="0">
                  <MuiBox className={classes.splashImageOnly}>
                    <FlexBox bg="x-light-gray" fullWidth height="100%">
                      <SplashViewImage alt="splash-view-image" src={`${previewUrl}${splashImage[0].s3Name}`} />
                    </FlexBox>
                  </MuiBox>
                </FlexBox>
              )}
            </>
          ) : (
            <FlexBox data-testid="splash-text" align="center" justify="center" direction="column" padding="0 15">
              <Box flexOverride="none" margin="0 0 3">
                {splashScreenHeader()}
              </Box>
              <Box flexOverride="none" margin="0 0 8">
                {splashScreenMessage()}
              </Box>
            </FlexBox>
          )}
        </Grid>
      </FlexBox>
      <Footer onNextClick={onNextButtonClick} nextText={splashbuttonText} hideBackButton />
    </>
  );
};

export default SplashView;
